"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _store = _interopRequireDefault(require("@/store"));
var _main = _interopRequireDefault(require("@/main"));
var _default = exports.default = {
  inserted: function inserted(el, binding, vnode) {
    var value = binding.value;
    var functions = _store.default.getters && _store.default.getters.functions;
    var pageName = value.pageName,
      list = value.list;
    if (list && list instanceof Array && list.length > 0) {
      var permissionList = functions[pageName] || [];
      var hasPermission = permissionList.some(function (item) {
        return list.includes(item);
      });
      if (!hasPermission) {
        _main.default.$nextTick(function () {
          el.parentNode && el.parentNode.removeChild(el);
        });
      }
      return true;
    } else {
      throw new Error("need function value! Like v-FPermission=\"LIST\"");
    }
  },
  update: function update(el, binding, vnode) {
    var value = binding.value;
    var functions = _store.default.getters && _store.default.getters.functions;
    var pageName = value.pageName,
      list = value.list;
    if (list && list instanceof Array && list.length > 0) {
      var permissionList = functions[pageName] || [];
      var hasPermission = permissionList.some(function (item) {
        return list.includes(item);
      });
      if (!hasPermission) {
        _main.default.$nextTick(function () {
          el.parentNode && el.parentNode.removeChild(el);
        });
      }
      return true;
    } else {
      throw new Error("need function value! Like v-FPermission=\"LIST\"");
    }
  }
};